import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 18.5L7.5 5C7.5 4.72386 7.27614 4.5 7 4.5C6.72386 4.5 6.5 4.72386 6.5 5L6.5 18.5C6.5 18.7761 6.72386 19 7 19C7.27614 19 7.5 18.7761 7.5 18.5ZM16.5 5L16.5 19C16.5 19.2761 16.7239 19.5 17 19.5C17.2761 19.5 17.5 19.2761 17.5 19L17.5 5C17.5 4.72386 17.2761 4.5 17 4.5C16.7239 4.5 16.5 4.72386 16.5 5Z",
			fill: "#2B2B2C"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPause;
